// extracted by mini-css-extract-plugin
module.exports = {"back":"recs_back__PoEHR","container":"recs_container__AIqu7","innerContainer":"recs_innerContainer__lKNt6","spinner":"recs_spinner__1s0gq","dark":"recs_dark__Rpb-5"};